import './button.scss';

export default function Button({ text, onClick, disabled }) {
  let className = `button ${disabled ? 'disabled' : ''}`;
  return (
    <button className={className} onClick={onClick} disabled={disabled} type="submit">
      {text}
    </button>
  )
}